import { useEffect, useState } from "react";
import { AlertTriangle, Percent } from "lucide-react";
import Modal from "./Modal";
import classNames from "./classNames";
import { fmt } from "./fmt";

export default function ConfirmActionModal({
  open,
  action,          // { type: "assign" | "unassign", row }
  onClose,
  onConfirm,
}) {
  // 🔥 Hooks MUST be at top-level
  const [margin, setMargin] = useState(0);
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(0);

  const isAssign = action?.type === "assign";
  const product = action?.row?.product || {};
  const isPercent = Number(product.is_percent) === 1;

  // ✅ Prefill values safely
  useEffect(() => {
    if (open && isAssign && action?.row) {
      setMargin(product.margin ?? 0);
      setMinValue(product.min_value ?? 0);
      setMaxValue(product.max_value ?? 0);
    }
  }, [open, isAssign, action, product]);

  // ✅ EARLY RETURN MUST COME AFTER HOOKS
  if (!open || !action) return null;

  const handleConfirm = () => {
    onConfirm({
      margin: Number(margin),
      min_value: Number(minValue),
      max_value: Number(maxValue),
    });
  };

  return (
    <Modal open={open} title="Please Confirm" onClose={onClose} max="max-w-xl">
      {/* Info */}
      <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4">
        <div className="flex items-start gap-3">
          <div className="rounded-2xl bg-white p-3 text-blue-700">
            <AlertTriangle className="h-5 w-5" />
          </div>

          <div className="min-w-0">
            <p className="text-sm font-semibold text-slate-900">
              {isAssign
                ? "Assign this product to company?"
                : "Unassign this product from company?"}
            </p>

            <p className="mt-1 text-xs font-semibold text-slate-600">
              Product:{" "}
              <span className="font-semibold">
                {fmt(product.name)}
              </span>
            </p>

            <p className="mt-1 text-xs font-semibold text-slate-600">
              Product ID:{" "}
              <span className="font-semibold">
                {fmt(action.row.product_id)}
              </span>
            </p>
          </div>
        </div>
      </div>

      {/* Assignment Inputs */}
      {isAssign && (
        <div className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-3">
          <div>
            <label className="text-xs font-semibold text-slate-600">
              Margin {isPercent ? "(%)" : "(₹)"}
            </label>

            <div className="relative">
              {isPercent ? (
                <Percent className="absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              ) : (
                <span className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400 font-bold">
                  ₹
                </span>
              )}

              <input
                type="number"
                value={margin}
                onChange={(e) => setMargin(e.target.value)}
                className="w-full rounded-xl border border-blue-100 bg-white py-2 pl-8 pr-3 text-sm font-semibold focus:ring-2 focus:ring-blue-200"
              />
            </div>
          </div>

          <div>
            <label className="text-xs font-semibold text-slate-600">
              Min Value (₹)
            </label>
            <input
              type="number"
              value={minValue}
              onChange={(e) => setMinValue(e.target.value)}
              className="w-full rounded-xl border border-blue-100 bg-white px-3 py-2 text-sm font-semibold focus:ring-2 focus:ring-blue-200"
            />
          </div>

          <div>
            <label className="text-xs font-semibold text-slate-600">
              Max Value (₹)
            </label>
            <input
              type="number"
              value={maxValue}
              onChange={(e) => setMaxValue(e.target.value)}
              className="w-full rounded-xl border border-blue-100 bg-white px-3 py-2 text-sm font-semibold focus:ring-2 focus:ring-blue-200"
            />
          </div>
        </div>
      )}

      {/* Actions */}
      <div className="mt-6 flex justify-end gap-2">
        <button
          type="button"
          onClick={onClose}
          className="rounded-xl border px-4 py-2 text-sm font-semibold text-blue-700"
        >
          Cancel
        </button>

        <button
          type="button"
          onClick={handleConfirm}
          className={classNames(
            "rounded-xl px-4 py-2 text-sm font-semibold text-white",
            isAssign
              ? "bg-emerald-600 hover:bg-emerald-700"
              : "bg-rose-600 hover:bg-rose-700"
          )}
        >
          {isAssign ? "Yes, Assign" : "Yes, Unassign"}
        </button>
      </div>
    </Modal>
  );
}





// import { AlertTriangle } from "lucide-react";
// import Modal from "./Modal";
// import classNames from "./classNames";
// import { fmt } from "./fmt";

// export default function ConfirmActionModal({
//   open,
//   action,          // { type: "assign" | "unassign", row }
//   onClose,
//   onConfirm,
// }) {
//   if (!open || !action) return null;

//   const isAssign = action.type === "assign";

//   return (
//     <Modal
//       open={open}
//       title="Please Confirm"
//       onClose={onClose}
//       max="max-w-xl"
//     >
//       {/* Message */}
//       <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4">
//         <div className="flex items-start gap-3">
//           <div className="rounded-2xl bg-white p-3 text-blue-700">
//             <AlertTriangle className="h-5 w-5" />
//           </div>

//           <div className="min-w-0">
//             <p className="text-sm font-semibold text-slate-900">
//               {isAssign
//                 ? "Assign this product to company?"
//                 : "Unassign this product from company?"}
//             </p>

//             <p className="mt-1 text-xs font-semibold text-slate-600">
//               Product:{" "}
//               <span className="font-semibold">
//                 {fmt(action.row?.product?.name)}
//               </span>
//             </p>

//             <p className="mt-1 text-xs font-semibold text-slate-600">
//               Product ID:{" "}
//               <span className="font-semibold">
//                 {fmt(action.row?.product_id)}
//               </span>
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Actions */}
//       <div className="mt-4 flex flex-col gap-2 md:flex-row md:justify-end">
//         <button
//           type="button"
//           onClick={onClose}
//           className="inline-flex items-center justify-center rounded-xl border border-blue-200 bg-white px-4 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-50"
//         >
//           Cancel
//         </button>

//         <button
//           type="button"
//           onClick={onConfirm}
//           className={classNames(
//             "inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold text-white",
//             isAssign
//               ? "bg-emerald-600 hover:bg-emerald-700"
//               : "bg-rose-600 hover:bg-rose-700"
//           )}
//         >
//           {isAssign ? "Yes, Assign" : "Yes, Unassign"}
//         </button>
//       </div>
//     </Modal>
//   );
// }
